import React from 'react';
// import ReactDOM from 'react-dom';
import { render } from "react-dom";
import './index.css';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import 'semantic-ui-css/semantic.min.css'


render(<App />, document.getElementById("root"));

serviceWorker.unregister();
